import { z } from "zod";

// Workspace user role enum
export const RoleEnumValues = ["ADMIN", "USER"] as const;
export type RoleEnumTypes = (typeof RoleEnumValues)[number];

// Workspace type enum
// Workspace types - split into public and private. This is to allow validator to prevent use of PERSONAL
export const WorkspaceTypeValuesPrivate = ["PERSONAL"] as const;
export const WorkspaceTypeValuesPublic = ["BASIC_SHARED"] as const;
export const WorkspaceTypeValuesAll = [
  ...WorkspaceTypeValuesPublic,
  ...WorkspaceTypeValuesPrivate,
] as const;
export type WorkspaceTypeEnumType = (typeof WorkspaceTypeValuesAll)[number];

// Research task status enum
export const ResearchTaskStatusValues = [
  "PENDING",
  "RUNNING",
  "COMPLETED",
  "FAILED",
] as const;
export type ResearchTaskStatusType = (typeof ResearchTaskStatusValues)[number];

// Research project type enum
export const ResearchProjectTypeValues = [
  "REPORT",
  "MULTIPLE_FACTS",
  "COMPARISON_TABLE",
] as const;
export const ResearchProjectTypeLabels: Record<
  ResearchProjectTypeEnumType,
  string
> = {
  REPORT: "Report",
  MULTIPLE_FACTS: "Multiple Facts",
  COMPARISON_TABLE: "Comparison Table",
};
export type ResearchProjectTypeEnumType =
  (typeof ResearchProjectTypeValues)[number];
export const ResearchProject = z.enum(ResearchProjectTypeValues);

// Research model enum
export const ResearchModelValues = [
  "exa-research-fast",
  "exa-research",
  "exa-research-pro",
] as const;
export type ResearchModelType = (typeof ResearchModelValues)[number];
export const ResearchModel = z.enum(ResearchModelValues);
